import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'text-question',
  templateUrl: 'text-question.html',
  styleUrls: ['text-question.scss'],
})
export class TextQuestionComponent {

  @Input()
  public title: string;

  @Input()
  public description: string;

  @Input()
  public value: string;

  @Output()
  public valueChange: EventEmitter<string> = new EventEmitter<string>();

  @Input()
  public valueOnly: boolean = false;

  @Input()
  public rows: string;

  @Input()
  public placeholder: string;

  public valueChanged(): void {
    this.valueChange.emit(this.value);
  }

}
